import React, { useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import MainLayout from "../../layouts/main_layout/main_layout";
import html2canvas from "html2canvas";
import { addDoc, collection } from "firebase/firestore";
import { firestore, storage } from "../..";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { type DeaneryOption as Deanery } from "../../utils/deanery_parishes";
interface Props {}

// Deanery List
export const deaneryList: Deanery[] = [
  { id: 1, name: "Kundapur" },
  { id: 2, name: "Udupi" },
  { id: 3, name: "Karkal" },
  { id: 4, name: "Kallianpur" },
  { id: 5, name: "Shirva" },
];

// Parish Lists
export const parishList: {
  id: number;
  value: string;
  deanery: string;
}[] = [
  { id: 1, value: "Basrur", deanery: "Kundapur" },
  { id: 2, value: "Belve", deanery: "Kundapur" },
  { id: 3, value: "Byndoor", deanery: "Kundapur" },
  { id: 4, value: "Kundapur", deanery: "Kundapur" },
  { id: 5, value: "Gangolli", deanery: "Kundapur" },
  { id: 6, value: "Kota", deanery: "Kundapur" },
  { id: 7, value: "Koteshwar", deanery: "Kundapur" },
  { id: 8, value: "Padukone", deanery: "Kundapur" },
  { id: 9, value: "Piusnagar", deanery: "Kundapur" },
  { id: 10, value: "Tallur", deanery: "Kundapur" },
  { id: 11, value: "Trasi", deanery: "Kundapur" },
  { id: 12, value: "Kerekatte", deanery: "Kundapur" },
  { id: 13, value: "Kandlur", deanery: "Kundapur" },
  { id: 14, value: "Ajekar", deanery: "Karkal" },
  { id: 15, value: "Hirgan", deanery: "Karkal" },
  { id: 16, value: "Miyar", deanery: "Karkal" },
  { id: 17, value: "Karkal-Attur", deanery: "Karkal" },
  { id: 18, value: "Karkal-Town", deanery: "Karkal" },
  { id: 19, value: "Parapady", deanery: "Karkal" },
  { id: 20, value: "Nakre ", deanery: "Karkal" },
  { id: 21, value: "Kanajar", deanery: "Karkal" },
  { id: 22, value: "Kera ", deanery: "Karkal" },
  { id: 23, value: "Belman", deanery: "Karkal" },
  { id: 24, value: "Kalathur", deanery: "Karkal" },
  { id: 25, value: "Kelmbet", deanery: "Karkal" },
  { id: 26, value: "Mudarangadi", deanery: "Shirva" },
  { id: 27, value: "Mukamar", deanery: "Shirva" },
  { id: 28, value: "Palimar", deanery: "Shirva" },
  { id: 29, value: "Pamboor ", deanery: "Shirva" },
  { id: 30, value: "Mundkur", deanery: "Shirva" },
  { id: 31, value: "Pernal ", deanery: "Shirva" },
  { id: 32, value: "Shirva", deanery: "Shirva" },
  { id: 33, value: "Pangla ", deanery: "Shirva" },
  { id: 34, value: "Pilar ", deanery: "Shirva" },
  { id: 35, value: "Moodubelle", deanery: "Shirva" },
  { id: 36, value: "Kalmady", deanery: "Udupi" },
  { id: 37, value: "Katapady", deanery: "Udupi" },
  { id: 38, value: "Kuntalnagar", deanery: "Udupi" },
  { id: 39, value: "Manipal", deanery: "Udupi" },
  { id: 40, value: "Perampally", deanery: "Udupi" },
  { id: 41, value: "Udupi", deanery: "Udupi" },
  { id: 42, value: "Udyavar", deanery: "Udupi" },
  { id: 43, value: "Yermal", deanery: "Udupi" },
  { id: 44, value: "Barkur", deanery: "Kallianpur" },
  { id: 45, value: "Brahmavar", deanery: "Kallianpur" },
  { id: 46, value: "Kolalgiri", deanery: "Kallianpur" },
  { id: 47, value: "Kallianpur-Milagres", deanery: "Kallianpur" },
  { id: 48, value: "Kallianpur-Mount Rosary", deanery: "Kallianpur" },
  { id: 49, value: "Thottam", deanery: "Kallianpur" },
  { id: 50, value: "Kemman", deanery: "Kallianpur" },
  { id: 51, value: "Pethri", deanery: "Kallianpur" },
  { id: 52, value: "Sastan", deanery: "Kallianpur" },
];

function Vanamahostava(props: Props) {
  const {} = props;

  const [photo, setPhoto] = useState<string | null>(null);
  const [name, setName] = useState("");
  const [parishName, setParishName] = useState<{
    id: number;
    value: string;
    deanery: string;
  } | null>(null);
  const captureRef = useRef<HTMLDivElement>(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setPhoto(reader.result as string);
      reader.readAsDataURL(file);
    }
  };

  // Convert data URL to Blob
  function dataURLtoBlob(dataurl: string) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  const handleDownload = async () => {
    const element = captureRef.current;

    element!.scrollLeft = 0;
    element!.scrollTop = 0;
    const originalOverflow = element!.style.overflow;
    element!.style.overflow = "visible";

    const canvas = await html2canvas(element!, {
      scrollX: 0,
      scrollY: 0,
      windowWidth: element!.scrollWidth,
      windowHeight: element!.scrollHeight,
      useCORS: true,
      scale: 4,
    });

    element!.style.overflow = originalOverflow;

    const image = canvas.toDataURL("image/png");

    // Fallback for iOS: Open image in new tab
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<img src="${image}" style="width:100%">`);
      } else {
        alert("Popup blocked. Please allow popups for this site.");
      }
    } else {
      const link = document.createElement("a");
      link.href = image;
      link.download = `${name}_${parishName?.value}.png`;
      link.click();

      const imageBlob = dataURLtoBlob(image);
      const imageStorageRef = ref(
        storage,
        `vanamahostava/${name}_${parishName?.value}.png`
      );
      const uploadTask = uploadBytesResumable(imageStorageRef, imageBlob);
      await uploadTask;
      const downloadURL = await getDownloadURL(imageStorageRef);
      addDoc(collection(firestore, "vanamahostava"), {
        name: name,
        parishName: parishName?.value,
        imageURL: downloadURL,
        deanery: parishName?.deanery,
      });
      // images.push(downloadURL); // Uncomment and define images if needed

      // Remove or update the following thumbnail code as needed
      // const thumbnailStorageRef = ref(storage, `news/${selectedThumbnail?.name}`);
      // const uploadTaskForTuhumbail = uploadBytesResumable(
      //   thumbnailStorageRef,
      //   selectedThumbnail!
      // );
      // await uploadTaskForTuhumbail;
      // const downloadURLThumb = await getDownloadURL(thumbnailStorageRef);
      // await Promise.all(promises!);
    }
  };

  return (
    <MainLayout>
      <Box mt={1}>
        <Grid container>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              Plant and Protect a Tree
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
              Trees are more than just part of nature—they are life-givers,
              protectors of the environment, and silent witnesses to our future.
              By planting a tree, we gift the earth clean air, shade, and
              stability. But planting alone isn't enough—protecting what we
              plant ensures that this gift grows into a legacy. Through this
              initiative, we invite you to be a guardian of green.
              <br /> Let’s join hands to make our surroundings sustainable and
              beautiful—one tree at a time. Every sapling planted and protected
              today will stand tall as a symbol of hope for the generations to
              come.
              <br />
              <strong>
                🌿 Kindly plant a tree, upload a photo of your green
                contribution, and become part of this noble movement. ✨Join the
                Youth Commission of the Udupi Diocese in this mission and let
                your tree tell a story of change.
              </strong>
            </Typography>
            <label
              htmlFor="upload-photo"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "#fff",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              Upload Photo
            </label>
            <input
              id="upload-photo"
              type="file"
              accept="image/*"
              onChange={handlePhotoUpload}
              style={{ display: "none" }}
            />

            <Box display={"flex"} flexDirection={"column"} mt={2}>
              <TextField
                size="small"
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => {
                  if (e.target.value.length <= 18) {
                    setName(e.target.value);
                  }
                }}
              />
              {/* <TextField
                size="small"
                type="text"
                placeholder="Enter your unit name"
                value={parishName}
                sx={{ mt: 1 }}
                onChange={(e) => {
                  if (e.target.value.length <= 15) {
                    setParishName(e.target.value);
                  }
                }}
              /> */}
            </Box>
            <Box mt={2}>
              <Autocomplete
                size="small"
                fullWidth
                value={
                  parishList.find(
                    (option) => parishName?.value === option.value
                  ) || null
                }
                onChange={(_event, value) => setParishName(value)}
                options={parishList}
                getOptionLabel={(option) => option.value || ""}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Unit name" />
                )}
              />
            </Box>
            <Button
              disabled={!photo || !name || !parishName}
              variant="outlined"
              onClick={handleDownload}
              sx={{
                width: "100%",
                mt: 2,
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              Download
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={6}
            xl={6}
            display={{ md: "flex", lg: "flex", xl: "flex" }}
            justifyContent={{ md: "center", lg: "center", xl: "center" }}
          >
            <Box
              ref={captureRef}
              width={340}
              height={560}
              sx={{
                mt: 2,
                display: "flex",
                my: 2,
                overflowX: "scroll",
              }}
              justifyContent={"center"}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                sx={{
                  border: "5px dashed #000000",
                  borderRadius: 2,
                  borderImageSlice: 1,
                }}
                bgcolor={"#d5ffdd"}
                m={1}
                position={"relative"}
              >
                <Box
                  sx={{ backgroundColor: "#053b2e" }}
                  justifyContent={"center"}
                  alignItems={"center"}
                  m={1}
                  borderRadius={2}
                  pt={1}
                  pb={1}
                  position={"relative"}
                >
                  <Typography
                    color="white"
                    fontWeight={600}
                    textAlign={"center"}
                    sx={{
                      fontFamily: `"Poppins", sans-serif;`,
                      color: "#efdeb9",
                      letterSpacing: "3px",
                      fontSize: 14,
                    }}
                  >
                    INDIAN CATHOLIC YOUTH MOVEMENT
                  </Typography>
                  <Typography
                    // variant="subtitle1"
                    color="white"
                    fontWeight={600}
                    textAlign={"center"}
                    sx={{
                      fontFamily: `"Poppins", sans-serif;`,
                      color: "#efdeb9",
                      letterSpacing: "3px",
                      fontSize: 14,
                    }}
                  >
                    DIOCESE OF UDUPI
                  </Typography>
                  <Box position={"absolute"} top={30} left={10}>
                    <img
                      src="/images/vanamahostava/logo_icym.png"
                      height={35}
                      width={35}
                      style={{ borderRadius: "50%" }}
                    />
                  </Box>
                  {/* <Box position={"absolute"} top={27} right={10}>
                    <img
                      src="/images/vanamahostava/ycs.jpg"
                      height={35}
                      width={35}
                      style={{ borderRadius: "50%" }}
                    />
                  </Box> */}
                </Box>
                <Box mt={1}>
                  <Typography
                    variant="h5"
                    sx={{ fontFamily: "Barabara, sans-serif" }}
                    px={1}
                    textAlign={"end"}
                  >
                    PLANT AND PROTECT A TREE
                  </Typography>
                </Box>

                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  mx={2}
                  position={"relative"}
                >
                  <Box
                    width={220}
                    height={220}
                    border="7px solid #053b2e"
                    borderRadius={"50%"}
                    overflow="hidden" // <-- Important
                    sx={{
                      backgroundImage: `url(${photo})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <img
                      src={photo!}
                      alt="Uploaded"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "fill",
                      }}
                    />
                  </Box>
                  <Box position={"absolute"} right={-20} top={18}>
                    <img
                      src="/images/vanamahostava/van_2.png"
                      height={90}
                      width={90}
                    />
                  </Box>
                  <Box position={"absolute"} bottom={-25} right={-17}>
                    <img
                      src="/images/vanamahostava/van_1.png"
                      height={80}
                      width={115}
                    />
                  </Box>
                  <Box
                    position={"absolute"}
                    bottom={70}
                    right={10}
                    sx={{
                      // opacity: 0.7,

                      zIndex: 9999,
                      backgroundColor: "#053b2e99",
                      borderRadius: 1,
                    }}
                    px={1}
                    py={0.5}
                  >
                    <Typography
                      textTransform={"uppercase"}
                      fontWeight={600}
                      color="white"
                      variant="subtitle2"
                      sx={{ fontFamily: `'Josefin Sans', sans-serif` }}
                    >
                      I will Protect This Plant
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    ml: 7.5,
                    mt: 0.5,
                    fontSize: 24,
                    color: "white",
                    fontWeight: "bold",
                    textShadow: "1px 1px 2px black",
                    backgroundColor: "#053b2e",
                    width: 140,
                    // minHeight: 45,
                    borderRadius: 1,
                  }}
                >
                  <Box>
                    <Typography
                      fontWeight={600}
                      textAlign={"center"}
                      fontSize={12}
                      mt={0.5}
                      textTransform={"capitalize"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      fontWeight={600}
                      textAlign={"center"}
                      fontSize={12}
                      pb={0.5}
                    >
                      {parishName?.value}
                    </Typography>
                  </Box>
                </Box>
                <Box display={"flex"} flexDirection={"column"} my={1} mx={2}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontFamily: "Gagalin, sans-serif" }}
                    textAlign={"center"}
                    fontWeight={600}
                  >
                    "A tree is not just a Plant. It's a Promise to the Future"
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  position={"absolute"}
                  bottom={40}
                  left={-40}
                >
                  <img
                    src="/images/vanamahostava/bottom_left.png"
                    height={80}
                    width={160}
                    style={{
                      transform: "rotate(270deg)",
                    }}
                  />
                </Box>
                <Box
                  display={"flex"}
                  position={"absolute"}
                  bottom={40}
                  left={40}
                >
                  <img
                    src="/images/vanamahostava/middle.png"
                    height={80}
                    width={160}
                    style={{
                      transform: "rotate(270deg)", // Rotate 45 degrees
                    }}
                  />
                </Box>
                <Box
                  display={"flex"}
                  position={"absolute"}
                  bottom={40}
                  left={120}
                >
                  <img
                    src="/images/vanamahostava/middle.png"
                    height={80}
                    width={160}
                    style={{
                      transform: "rotate(270deg)",
                    }}
                  />
                </Box>
                <Box
                  display={"flex"}
                  position={"absolute"}
                  bottom={40}
                  left={190}
                >
                  <img
                    src="/images/vanamahostava/middle.png"
                    height={80}
                    width={160}
                    style={{
                      transform: "rotate(270deg)",
                    }}
                  />
                </Box>
                <Box
                  display={"flex"}
                  position={"absolute"}
                  bottom={40}
                  left={194}
                >
                  <img
                    src="/images/vanamahostava/bottom_right.png"
                    height={80}
                    width={160}
                    style={{
                      transform: "rotate(270deg)",
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </MainLayout>
  );
}

export default Vanamahostava;
